import HelpSection from "../../../../src/pages/apis/microsoft-PA-integration/left-content.md";
import QuestionsSection from "../../../../src/pages/apis/microsoft-PA-integration/right-content.md";
import * as React from 'react';
export default {
  HelpSection,
  QuestionsSection,
  React
};